export const environment = {
  production: false,
  seed: 'tgrdev-application-session.seed.json'
};
